import React from 'react'
import { Grid, Header, Icon, Segment, SegmentProps, SemanticICONS } from 'semantic-ui-react'

interface DashboardSegmentProps extends Pick<SegmentProps, 'color' | 'inverted' | 'loading'> {
  title: string
  subTitle?: string
  icon: SemanticICONS
  value: React.ReactElement<typeof Grid.Column>
}

export const DashboardSegment: React.FC<DashboardSegmentProps> = ({ title, subTitle, icon, value, color, inverted = true, loading }) => {
  return (
    <Segment className='segment-dashboard-home' color={color} inverted={inverted} loading={loading} textAlign='center'>
      <Header inverted={inverted}>
        {title}
        {subTitle && (
          <Header.Subheader className='overflow-ellipsis' title={subTitle}>
            {subTitle}
          </Header.Subheader>
        )}
      </Header>
      <Grid columns='equal'>
        <Grid.Row className='row-dashboard'>
          <Grid.Column className='segment-icon'>
            <Icon name={icon} size='large' />
          </Grid.Column>
          {value}
        </Grid.Row>
      </Grid>
    </Segment>
  )
}
